var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('output-dialog',{ref:"printDlg",attrs:{"aspectRatio":1000/1132,"background":require('@/assets/img/SjlModel.jpg'),"fields":_vm.fields,"pages":_vm.pages,"filename":"SjlModel.pdf","orientation":"portrait","title":"事業本部 登録用紙"}})}
var staticRenderFns = []

export { render, staticRenderFns }